// extracted by mini-css-extract-plugin
export default {"inputLabel":"EditField-module_inputLabel_TqANpn"};